module.exports = __webpack_public_path__ + "img/Google_Data_Studio.91927a0f.png";